import { render } from "./PreferredOJTLocationDataTable.vue?vue&type=template&id=03589194&scoped=true"
import script from "./PreferredOJTLocationDataTable.vue?vue&type=script&lang=js"
export * from "./PreferredOJTLocationDataTable.vue?vue&type=script&lang=js"

import "./PreferredOJTLocationDataTable.vue?vue&type=style&index=0&id=03589194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03589194"]])

export default __exports__